import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { RESET_LINK, RESET_PASSWORD } from '../api';

export default {
    namespaced: true,
    state: { reset_link: request_state(), reset_password: request_state() },
    mutations: {
        ...request_mutations('reset_link', 'reset_link'),
        ...request_mutations('reset_password', 'reset_password'),
    },
    actions: {
        reset_link({ commit }, data) {
            commit('reset_link_loading');
            return new Promise((resolve) => {
                axios.post(RESET_LINK, data).then((response) => {
                    commit('reset_link_success', response.data);
                    resolve();
                }).catch(error => commit('reset_link_error', error.response ? error.response.data : {}));
            });
        },
        reset_password({ commit }, data) {
            commit('reset_password_loading');
            return new Promise((resolve) => {
                axios.put(RESET_PASSWORD, data).then((response) => {
                    commit('reset_password_success', response.data);
                    resolve();
                }).catch(error => commit('reset_password_error', error.response ? error.response.data : {}));
            });
        },
    },
};
